var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.80313 10.8H10.2031C10.3731 10.8 10.5156 10.8575 10.6306 10.9725C10.7456 11.0875 10.8031 11.23 10.8031 11.4C10.8031 11.57 10.7456 11.7125 10.6306 11.8275C10.5156 11.9425 10.3731 12 10.2031 12H1.80313C1.63313 12 1.49063 11.9425 1.37563 11.8275C1.26063 11.7125 1.20312 11.57 1.20312 11.4C1.20312 11.23 1.26063 11.0875 1.37563 10.9725C1.49063 10.8575 1.63313 10.8 1.80313 10.8ZM6.00313 9.225C5.91313 9.225 5.82563 9.205 5.74063 9.165C5.65563 9.125 5.58313 9.065 5.52313 8.985L2.55313 5.175C2.40313 4.975 2.38313 4.7625 2.49313 4.5375C2.60313 4.3125 2.78313 4.2 3.03313 4.2H4.20312V0.6C4.20312 0.43 4.26063 0.2875 4.37563 0.1725C4.49063 0.0575 4.63313 0 4.80313 0H7.20312C7.37313 0 7.51563 0.0575 7.63063 0.1725C7.74563 0.2875 7.80313 0.43 7.80313 0.6V4.2H8.97313C9.22313 4.2 9.40313 4.3125 9.51313 4.5375C9.62313 4.7625 9.60313 4.975 9.45312 5.175L6.48313 8.985C6.42313 9.065 6.35063 9.125 6.26562 9.165C6.18062 9.205 6.09313 9.225 6.00313 9.225Z",
    fill: "#003DA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.315a1c8ac1826a4f59e4a3d879bf2d90.svg";
export { ForwardRef as ReactComponent };